const formatReason = (reasonCode, additionalExplanation, label) =>
  additionalExplanation
    ? `${reasonCode}${reasonCode === 'FR' ? label.replaceAll(' ', '-').replace('', '_') : ''}_${additionalExplanation}`
    : reasonCode;

export default formatReason;
